'use client';

import { IconAlertTriangle, IconCircleCheck, IconCircleX, IconInfoCircle, IconLoader2 } from '@tabler/icons-react';
import { useLocale } from 'next-intl';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useMediaQuerySafe } from '@/hooks/useMediaQuerySafe';

const Toaster = ({ ...props }: ToasterProps) => {
  const locale = useLocale();
  const isMobile = useMediaQuerySafe('(max-width: 1023px)');

  return (
    <Sonner
      theme='light'
      className='toaster group'
      position={isMobile ? 'top-center' : 'bottom-right'}
      dir={locale === 'he' ? 'rtl' : 'ltr'}
      visibleToasts={3}
      duration={4000}
      mobileOffset={{ top: 'calc(16px + env(safe-area-inset-top))', left: 16, right: 16 }}
      icons={{
        success: <IconCircleCheck className='size-4 text-primary-green-day' />,
        info: <IconInfoCircle className='size-4 text-[#0B51B3]' />,
        warning: <IconAlertTriangle className='size-4 text-brand-orange' />,
        error: <IconCircleX className='size-4 text-red-day' />,
        loading: <IconLoader2 className='size-4 animate-spin text-text-disabled-day' />,
      }}
      style={
        {
          '--normal-bg': '#ffffff',
          '--normal-text': 'var(--color-text-primary-day)',
          '--normal-border': 'var(--color-brand-border)',
          '--border-radius': '12px',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
